export default "__VITE_ASSET__c10ad635__"